import * as React from 'react';
import { ConfigProvider, Timeline } from 'antd';
import RoadmapCards from './RoadmapCards';


export default function ListComponent({questions}) {
    const items1 = []

    for (let i=0; i < questions.length; i++) {

        items1.push({
            color: 'none',
            children: (
                <>
                    <RoadmapCards data={questions[i]} type={"list"} index={i}/>
                </>
            )
        })

    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    Timeline: {
                        tailColor: '#B557AF',
                    },
                },
                token: {
                    lineType: 'dashed',
                }
            }}
        >
            <Timeline
                mode='alternate'
                items={items1}
            />

        </ConfigProvider>
    )
};